import React, { useEffect, useState } from "react";
import {
  Box,
  CardActionArea,
  Button,
  Card,
  Chip,
  Grid,
  IconButton,
  Paper,
  Typography,
  Modal,
  CardContent,
  Alert,
  Snackbar,
} from "@mui/material";
import { minWidth, Stack } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import {
  createSearchParams,
  Link as LinkRRD,
  useNavigate,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LoadingUI from "../../common/LoadingUI";
import { paymentRequestListAction } from "../../redux/toolkit/payments/payment-request-lists";
import PaymentDetails from "./PaymentDetails";
import { bankListAction } from "../../redux/toolkit/accountDetail.jsx/banklist";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import TaskAltRoundedIcon from "@mui/icons-material/TaskAltRounded";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import moment from "moment";
import { monthWiseEarningAction } from "../../redux/toolkit/payments/month-wise-earning";
import MonthWiseEarning from "./MonthWiseEarning";
import EditIcon from "@mui/icons-material/Edit";
import NoDataFound from "../../common/NoDataFound";
import { monthWiseChargebackAction } from "../../redux/toolkit/payments/month-wise-chargeback";

function List() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [publisher_id, setPublisher_id] = useState();
  const [pageSize, setPageSize] = useState(5);
  const [createPay, setCreatePay] = useState(false);
  const [payDetail, setPayDetail] = useState(false);
  const [paymentId, setPaymentId] = useState("");
  const [bankNotVerified, setBankNotVerified] = useState(false);
  const paymentList = useSelector((state) => state.paymentList);
  const { status, data, loading: listLoading } = paymentList;
  const bankList = useSelector((state) => state.listBank);
  const { status: bankStatus, data: bankData, loading: bankLoading } = bankList;
  const monthWiseEarningData = useSelector((state) => state.monthWiseEarning);
  const monthWiseChargebackData = useSelector(
    (state) => state.monthWiseChargeback
  );
  const { data: totalEarning } = monthWiseEarningData;

  const myProfile = useSelector((state) => state.myProfile);
  const {
    status: profileStatus,
    data: profileData,
    loading: profileLoading,
  } = myProfile;

  const [alertOpen, setAlertOpen] = useState(false);
  const handleCardClick = () => {
    if (bankData?.length > 0) {
      setAlertOpen(true);
    } else {
      navigate("/add-account");
    }
  };

  useEffect(() => {
    dispatch(paymentRequestListAction({ page: 0, limit: 100 }));
    dispatch(bankListAction());
  }, [dispatch]);

  useEffect(() => {
    monthWiseEarningAction();
  }, [dispatch]);

  useEffect(() => {
    dispatch(monthWiseEarningAction());
    dispatch(monthWiseChargebackAction());
  }, [dispatch]);

  const AppColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      minWidth: 50,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => params?.api?.getRowIndex(params.row._id) + 1,
    },

    {
      field: "created_at",
      headerName: "Created At",
      flex: 1,
      minWidth: 170,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <>
            {params?.row?.created_at
              ? moment(params?.row?.created_at)
                  .local()
                  .format("DD-MM-YYYY hh:mm:ss A")
              : "N/A"}
          </>
        );
      },
    },

    {
      field: "credit_at",
      headerName: "Sent date",
      flex: 1,
      minWidth: 170,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <>
            {params?.row?.credit_at
              ? moment(params?.row?.credit_at)
                  .local()
                  .format("DD-MM-YYYY hh:mm:ss A")
              : "N/A"}
          </>
        );
      },
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 1,
      minWidth: 150,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <>
            <Typography>{params?.row?.amount + " "}$</Typography>
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 170,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <>
            {params?.row?.status === "requested" && (
              <Chip label="Pending" color="warning" />
            )}

            {params?.row?.status === "approved" && (
              <Chip label="Approved" color="error" />
            )}

            {params?.row?.status === "credited" && (
              <Chip label="Paid" color="success" />
            )}
          </>
        );
      },
    },
    {
      field: "invoice",
      headerName: "Credit Note",
      flex: 1,
      minWidth: 170,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <>
            {params?.row?.invoice ? (
              <img src={params?.row?.invoice} width="50px" alt="invoice" />
            ) : (
              "N/A"
            )}
            <br />
            {params?.row?.invoice && (
              <DownloadForOfflineIcon
                onClick={() => {
                  window.open(params?.row?.invoice);
                }}
              />
            )}
          </>
        );
      },
    },
    {
      field: "invoice_verification_receipt",
      headerName: "Invoice Verification Receipt",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <>
            {params?.row?.invoice_verification_receipt ? (
              <img
                src={params?.row?.invoice_verification_receipt}
                width="50px"
                alt="invoice"
              />
            ) : (
              "N/A"
            )}
            <br />
            {params?.row?.invoice_verification_receipt && (
              <DownloadForOfflineIcon
                onClick={() => {
                  window.open(params?.row?.invoice_verification_receipt);
                }}
              />
            )}
          </>
        );
      },
    },
  ];

  return (
    <>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        justifyContent="space-between"
        alignItems={{ xs: "stretch", sm: "center" }}
        sx={{ mb: 2 }}
      >
        <Button
          variant="outlined"
          sx={{
            color: "#213448",
            borderColor: "#000334",
            textTransform: "none",
            padding: "10px 20px",
            fontWeight: "bold",
            width: { xs: "100%", sm: "auto" },
          }}
        >
          Available Amount :{" "}
          {Number(
            totalEarning?.length > 0 &&
              totalEarning?.reduce((a, b) => a + b.totalEarningsWithBonus, 0)
          ).toFixed(4)}{" "}
          $
        </Button>

        <Button
          variant="outlined"
          sx={{
            color: "#213448",
            borderColor: "#000334",
            textTransform: "none",
            padding: "10px 20px",
            fontWeight: "bold",
            width: { xs: "100%", sm: "auto" },
          }}
        >
          Total Widthdraw Amount :{" "}
          {Number(profileData.total_widthdraw_amount || 0).toFixed(4)} $
        </Button>

        <Button
          variant="outlined"
          sx={{
            color: "#213448",
            borderColor: "#000334",
            textTransform: "none",
            padding: "10px 20px",
            fontWeight: "bold",
            width: { xs: "100%", sm: "auto" },
          }}
        >
          Total Earned Amount :{" "}
          {Number(
            totalEarning?.length > 0 &&
              totalEarning?.reduce((a, b) => a + b.totalEarningsWithBonus, 0)
          ).toFixed(4)}{" "} $
        </Button>
      </Stack>

      <Paper
        sx={{
          marginTop: 2,
          bgcolor: "#fff",
          "& .super-app-theme--header": {
            background: "rgba(254, 206, 113, 0.16)",
            color: "#000",
            borderBottom: " 1px solid #000",
            fontFamily: "Open Sans",
            fontSize: "13px",
          },
        }}
        elevation={0}
      >
        <DataGrid
          sx={{
            border: " 1px solid #000",
            "& .MuiDataGrid-row:hover": {
              background: "rgba(254, 206, 113, 0.16)",
              cursor: "pointer",
            },
          }}
          getRowHeight={({ densityFactor }) => {
            return 70 * densityFactor;
          }}
          autoHeight
          rows={data}
          columns={AppColumns}
          getRowId={(row) => row._id}
          disableSelectionOnClick
          experimentalFeatures={{ newEditingApi: true }}
          pagination
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 15]}
          disableColumnSelector
          loading={listLoading ? <LoadingUI /> : false}
          onCellClick={(params) => {
            setPublisher_id(params?.row?._id);
          }}
          components={{
            NoRowsOverlay: () => <NoDataFound />,
            // Toolbar: GridToolbar,
          }}
        />
      </Paper>
      <Grid container sx={{ mt: 2 }} columnGap={2}>
        <Grid item xs={3}>
          <Card
            elevation={0}
            sx={{
              background: "rgba(254, 206, 113, 0.16)",
              borderRadius: "11px",
            }}
          >
            <CardActionArea sx={{ p: 2 }} onClick={handleCardClick}>
              <Stack alignItems="center" justifyContent="space-between">
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  color="rgba(47, 52, 62, 1)"
                >
                  Add Bank Details
                </Typography>
                <IconButton>
                  <AddIcon fontSize="large" />
                </IconButton>
              </Stack>
            </CardActionArea>
          </Card>
          <Snackbar
            open={alertOpen}
            autoHideDuration={6000}
            onClose={() => setAlertOpen(false)}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={() => setAlertOpen(false)}
              severity="warning"
              sx={{ width: "100%" }}
            >
              Bank details already exist.
            </Alert>
          </Snackbar>
        </Grid>

        {bankData?.length > 0 && (
          <Grid items xs={3}>
            <Card
              elevation={0}
              sx={{
                background: "rgba(254, 206, 113, 0.16)",
                borderRadius: "11px",
              }}
            >
              <CardActionArea sx={{ p: 2 }}>
                <Stack alignItems="center" justifyContent={"space-between"}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={600}
                    color="rgba(47, 52, 62, 1)"
                  >
                    Request Withdraw Amount
                  </Typography>
                  <IconButton>
                    <AddIcon
                      fontSize="large"
                      onClick={() => {
                        if (bankData?.length > 0) {
                          if (bankData[0]?.is_verified === 0) {
                            setBankNotVerified(true);
                          } else {
                            setCreatePay(true);
                            setBankNotVerified(false);
                          }
                        }
                      }}
                    />
                  </IconButton>
                </Stack>
              </CardActionArea>
            </Card>
          </Grid>
        )}
      </Grid>

      {/* <Card
        elevation={0}
        sx={{
          background: "rgba(254, 206, 113, 0.16)",
          borderRadius: "11px",
          p: 2,
          mt: 2,
        }}
      >
        <Typography sx={{ my: 2 }} variant="h6" color="primary">
          Bank Details
        </Typography>
        {bankData?.map((items, index) => {
          return (
            <Box key={index} sx={{ mt: 1 }}>
              <Stack>
                <Stack
                  direction={"row"}
                  alignItems="center"
                  justifyContent={"space-between"}
                >
                  <Stack direction={"row"} alignItems="center">
                    <AccountBalanceIcon fontSize="large" />
                    <Stack>
                      <Typography sx={{ ml: 2 }} variant="subtitle2">
                        Bank transfer
                      </Typography>
                      {bankLoading ? (
                        <LoadingUI />
                      ) : (
                        <Typography sx={{ ml: 2 }} color="primary" variant="h6">
                          {items?.account_no}
                        </Typography>
                      )}
                    </Stack>
                  </Stack>

                  <Box>
                    <IconButton
                      sx={{
                        fontSize: 40,
                        color: "#1976d2",
                        width: "1em",
                        height: "1em",

                        transition:
                          "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                        fontSize: "1.5rem",
                        color: "#1976d2",
                      }}
                    >
                      {items.is_verified == 1 && (
                        <TaskAltRoundedIcon sx={{ color: "#00FF00" }} />
                      )}
                      {items.is_verified == 0 && (
                        <CancelOutlinedIcon sx={{ color: "#FF0000" }} />
                      )}
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        navigate({
                          pathname: `/update-account`,
                          search: createSearchParams({
                            bank_id: items?._id,
                          }).toString(),
                        });
                      }}
                    >
                      <EditIcon color="primary" />
                    </IconButton>
                  </Box>
                </Stack>
              </Stack>
            </Box>
          );
        })}
      </Card> */}

      <Card
        elevation={0}
        sx={{
          background: "rgba(254, 206, 113, 0.16)",
          borderRadius: "11px",
          p: 2,
          mt: 2,
        }}
      >
        <Typography sx={{ my: 2 }} variant="h6" color="primary">
          Bank Details
        </Typography>

        {bankData?.map((items, index) => (
          <Box key={index} sx={{ mt: 1 }}>
            <Stack spacing={1}>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                alignItems={{ xs: "flex-start", sm: "center" }}
                justifyContent="space-between"
                spacing={2}
              >
                {/* Bank Icon + Info */}
                <Stack
                  direction="row"
                  alignItems="center"
                  sx={{ width: "100%" }}
                  spacing={2}
                >
                  <AccountBalanceIcon fontSize="large" />
                  <Stack>
                    <Typography variant="subtitle2">Bank transfer</Typography>
                    {bankLoading ? (
                      <LoadingUI />
                    ) : (
                      <Typography color="primary" variant="h6">
                        {items?.account_no}
                      </Typography>
                    )}
                  </Stack>
                </Stack>

                {/* Status + Edit Icons */}
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ mt: { xs: 2, sm: 0 } }}
                  justifyContent={{ xs: "flex-start", sm: "flex-end" }}
                  alignItems="center"
                  flexWrap="wrap"
                >
                  <IconButton
                    sx={{
                      fontSize: "1.5rem",
                      color: items.is_verified ? "#00FF00" : "#FF0000",
                    }}
                  >
                    {items.is_verified === 1 ? (
                      <TaskAltRoundedIcon />
                    ) : (
                      <CancelOutlinedIcon />
                    )}
                  </IconButton>

                  <IconButton
                    onClick={() => {
                      navigate({
                        pathname: `/update-account`,
                        search: createSearchParams({
                          bank_id: items?._id,
                        }).toString(),
                      });
                    }}
                  >
                    <EditIcon color="primary" />
                  </IconButton>
                </Stack>
              </Stack>
            </Stack>
          </Box>
        ))}
      </Card>

      {createPay && (
        <MonthWiseEarning state={createPay} setState={setCreatePay} />
      )}
      <PaymentDetails
        paymentId={paymentId}
        state={payDetail}
        setState={setPayDetail}
      />

      <Modal
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        fullscreen
        open={bankNotVerified}
        onClose={() => setBankNotVerified(false)}
      >
        <Card sx={{ width: "40%" }}>
          <CardContent>
            <Typography variant="subtitle1" color="primary">
              Bank Account is not verified yet, Please wait until it gets
              verified
            </Typography>
          </CardContent>
          <CardActionArea
            sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}
          >
            <Button
              onClick={() => setBankNotVerified(false)}
              variant="contained"
              color="primary"
            >
              OK
            </Button>
          </CardActionArea>
        </Card>
      </Modal>
    </>
  );
}

export default List;
